module.exports = __webpack_public_path__ + "img/main.d4b3ed82.png";